// extracted by mini-css-extract-plugin
export default {"main":"instaporkest_main__gEprW","logoJeugd":"instaporkest_logoJeugd__dN5hN"};